import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../utils/api.types";
import { fetchUnits } from "./unitsThunk";

interface UnitsSliceState {
  units: any[];
  byId: Record<string, any>;
  status: ApiStatus;
}

const initialState: UnitsSliceState = { units: [], byId: {}, status: ApiStatus.IDLE };

const unitsSlice = createSlice({
  name: "units",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUnits.pending, (state) => {
        state.status = ApiStatus.LOADING;
      })
      .addCase(fetchUnits.fulfilled, (state, action: any) => {
        state.status = ApiStatus.SUCCESS;
        const list = Array.isArray(action.payload) ? action.payload : action.payload?.units || [];
        state.units = list;
        state.byId = list.reduce((acc: Record<string, any>, u: any) => {
          acc[u._id] = u;
          return acc;
        }, {});
      })
      .addCase(fetchUnits.rejected, (state) => {
        state.status = ApiStatus.FAILED;
      });
  },
});

export default unitsSlice.reducer;
